import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function ContentSupplierPage() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('dashboard');

  useEffect(() => {
    const isAuthenticated = sessionStorage.getItem('content_supplier_auth');
    if (!isAuthenticated) {
      navigate('/content-supplier/login');
    }
  }, [navigate]);

  const tabs = [
    { id: 'dashboard', label: '대시보드', icon: 'ri-dashboard-line' },
    { id: 'contents', label: '콘텐츠 관리', icon: 'ri-book-open-line' },
    { id: 'revenue', label: '수익 관리', icon: 'ri-money-dollar-circle-line' },
    { id: 'analytics', label: '분석', icon: 'ri-bar-chart-line' },
    { id: 'talent', label: '달란트 정산', icon: 'ri-coin-line' }
  ];

  const contents = [
    { id: 1, title: '오늘의 묵상: 시편 23편', category: '묵상', views: 1234, talent: 620, revenue: 31000, date: '2025-01-15' },
    { id: 2, title: '찬양 워십: 주님의 사랑', category: '찬양', views: 2456, talent: 1228, revenue: 61400, date: '2025-01-10' },
    { id: 3, title: '성경공부: 요한복음', category: '성경공부', views: 3789, talent: 1894, revenue: 94700, date: '2025-01-05' },
    { id: 4, title: '간증: 하나님의 은혜', category: '간증', views: 1567, talent: 783, revenue: 39150, date: '2025-01-03' }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      
      <div className="pt-32 pb-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="mb-8">
            <h1 className="text-4xl font-bold text-gray-900 mb-2">콘텐츠 공급사 관리</h1>
            <p className="text-gray-600">콘텐츠를 관리하고 수익을 확인하세요</p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
            <div className="lg:col-span-1">
              <div className="bg-white rounded-xl shadow-sm p-6 mb-6">
                <div className="text-center mb-6">
                  <div className="w-24 h-24 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-video-line text-4xl text-purple-600"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-1">믿음미디어</h3>
                  <p className="text-sm text-gray-600">공급사 ID: C12345</p>
                </div>
                <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-lg p-4">
                  <p className="text-sm text-gray-600 mb-1">이번 달 수익</p>
                  <p className="text-2xl font-bold text-gray-900">₩1,850,000</p>
                </div>
              </div>

              <div className="bg-white rounded-xl shadow-sm overflow-hidden">
                {tabs.map((tab) => (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`w-full px-6 py-4 flex items-center space-x-3 transition-colors cursor-pointer ${
                      activeTab === tab.id
                        ? 'bg-purple-50 text-purple-600 border-r-4 border-purple-600'
                        : 'text-gray-700 hover:bg-gray-50'
                    }`}
                  >
                    <i className={`${tab.icon} text-xl`}></i>
                    <span className="font-medium">{tab.label}</span>
                  </button>
                ))}
              </div>
            </div>

            <div className="lg:col-span-3">
              {activeTab === 'dashboard' && (
                <div className="space-y-6">
                  <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
                    <div className="bg-white rounded-xl shadow-sm p-6">
                      <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4">
                        <i className="ri-book-open-line text-2xl text-purple-600"></i>
                      </div>
                      <p className="text-sm text-gray-600 mb-1">등록 콘텐츠</p>
                      <p className="text-3xl font-bold text-gray-900">248</p>
                    </div>
                    <div className="bg-white rounded-xl shadow-sm p-6">
                      <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                        <i className="ri-eye-line text-2xl text-blue-600"></i>
                      </div>
                      <p className="text-sm text-gray-600 mb-1">총 조회수</p>
                      <p className="text-3xl font-bold text-gray-900">125K</p>
                    </div>
                    <div className="bg-white rounded-xl shadow-sm p-6">
                      <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
                        <i className="ri-money-dollar-circle-line text-2xl text-green-600"></i>
                      </div>
                      <p className="text-sm text-gray-600 mb-1">이번 달 수익</p>
                      <p className="text-2xl font-bold text-gray-900">₩1.85M</p>
                    </div>
                    <div className="bg-white rounded-xl shadow-sm p-6">
                      <div className="w-12 h-12 bg-amber-100 rounded-lg flex items-center justify-center mb-4">
                        <i className="ri-coin-line text-2xl text-amber-600"></i>
                      </div>
                      <p className="text-sm text-gray-600 mb-1">달란트 적립</p>
                      <p className="text-2xl font-bold text-gray-900">92.5K</p>
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="bg-white rounded-xl shadow-sm p-6">
                      <h3 className="text-lg font-bold text-gray-900 mb-4">인기 콘텐츠</h3>
                      <div className="space-y-3">
                        {contents.slice(0, 3).map((content) => (
                          <div key={content.id} className="flex items-center justify-between pb-3 border-b border-gray-100 last:border-0">
                            <div className="flex-1">
                              <p className="font-medium text-gray-900 text-sm line-clamp-1">{content.title}</p>
                              <p className="text-xs text-gray-600">{content.category}</p>
                            </div>
                            <div className="text-right ml-4">
                              <p className="text-sm font-semibold text-gray-900">{content.views.toLocaleString()}</p>
                              <p className="text-xs text-gray-600">조회</p>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className="bg-white rounded-xl shadow-sm p-6">
                      <h3 className="text-lg font-bold text-gray-900 mb-4">카테고리별 분포</h3>
                      <div className="space-y-3">
                        {[
                          { category: '묵상', count: 85, percent: 34 },
                          { category: '찬양', count: 62, percent: 25 },
                          { category: '성경공부', count: 48, percent: 19 },
                          { category: '설교', count: 53, percent: 22 }
                        ].map((item) => (
                          <div key={item.category}>
                            <div className="flex items-center justify-between mb-1">
                              <span className="text-sm text-gray-600">{item.category}</span>
                              <span className="text-sm font-semibold text-gray-900">{item.count}개</span>
                            </div>
                            <div className="w-full bg-gray-200 rounded-full h-2">
                              <div className="bg-purple-600 h-2 rounded-full" style={{ width: `${item.percent}%` }}></div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  <div className="bg-white rounded-xl shadow-sm p-6">
                    <h3 className="text-xl font-bold text-gray-900 mb-6">최근 업로드 콘텐츠</h3>
                    <div className="space-y-4">
                      {contents.map((content) => (
                        <div key={content.id} className="flex items-center justify-between p-4 border border-gray-200 rounded-lg hover:shadow-md transition-all cursor-pointer">
                          <div className="flex-1">
                            <h4 className="font-semibold text-gray-900 mb-2">{content.title}</h4>
                            <div className="flex items-center space-x-4 text-sm text-gray-600">
                              <span className="px-2 py-1 bg-purple-100 text-purple-700 rounded text-xs font-medium">
                                {content.category}
                              </span>
                              <div className="flex items-center space-x-1">
                                <i className="ri-eye-line"></i>
                                <span>{content.views.toLocaleString()}</span>
                              </div>
                              <div className="flex items-center space-x-1">
                                <i className="ri-coin-line text-amber-600"></i>
                                <span className="text-amber-600 font-semibold">{content.talent.toLocaleString()}</span>
                              </div>
                              <span>{content.date}</span>
                            </div>
                          </div>
                          <div className="text-right ml-4">
                            <p className="text-lg font-bold text-green-600">₩{content.revenue.toLocaleString()}</p>
                            <p className="text-xs text-gray-600">수익</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}

              {activeTab === 'contents' && (
                <div className="bg-white rounded-xl shadow-sm p-6">
                  <div className="flex items-center justify-between mb-6">
                    <h3 className="text-xl font-bold text-gray-900">콘텐츠 관리</h3>
                    <button className="px-4 py-2 bg-purple-600 text-white text-sm font-semibold rounded-lg hover:bg-purple-700 transition-colors whitespace-nowrap cursor-pointer">
                      <i className="ri-add-line mr-2"></i>
                      콘텐츠 업로드
                    </button>
                  </div>

                  <div className="mb-6">
                    <div className="flex flex-wrap gap-3">
                      {['전체', '묵상', '찬양', '성경공부', '설교', '간증'].map((category) => (
                        <button
                          key={category}
                          className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-purple-100 hover:text-purple-700 transition-colors text-sm font-medium whitespace-nowrap cursor-pointer"
                        >
                          {category}
                        </button>
                      ))}
                    </div>
                  </div>

                  <div className="overflow-x-auto">
                    <table className="w-full">
                      <thead>
                        <tr className="border-b border-gray-200">
                          <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">제목</th>
                          <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">카테고리</th>
                          <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">조회수</th>
                          <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">달란트</th>
                          <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">수익</th>
                          <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">날짜</th>
                          <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">관리</th>
                        </tr>
                      </thead>
                      <tbody>
                        {contents.map((content) => (
                          <tr key={content.id} className="border-b border-gray-100 hover:bg-gray-50">
                            <td className="py-4 px-4 text-sm font-medium text-gray-900">{content.title}</td>
                            <td className="py-4 px-4">
                              <span className="px-2 py-1 bg-purple-100 text-purple-700 rounded text-xs font-medium">
                                {content.category}
                              </span>
                            </td>
                            <td className="py-4 px-4 text-sm text-gray-900">{content.views.toLocaleString()}</td>
                            <td className="py-4 px-4 text-sm text-amber-600 font-semibold">{content.talent.toLocaleString()}</td>
                            <td className="py-4 px-4 text-sm text-green-600 font-semibold">₩{content.revenue.toLocaleString()}</td>
                            <td className="py-4 px-4 text-sm text-gray-600">{content.date}</td>
                            <td className="py-4 px-4">
                              <button className="text-purple-600 hover:text-purple-700 mr-3 cursor-pointer">
                                <i className="ri-edit-line text-lg"></i>
                              </button>
                              <button className="text-red-600 hover:text-red-700 cursor-pointer">
                                <i className="ri-delete-bin-line text-lg"></i>
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {activeTab === 'revenue' && (
                <div className="space-y-6">
                  <div className="bg-gradient-to-br from-purple-600 to-purple-700 rounded-xl shadow-lg p-8 text-white">
                    <p className="text-lg mb-2">총 수익</p>
                    <p className="text-5xl font-bold mb-6">₩22,200,000</p>
                    <div className="grid grid-cols-3 gap-4">
                      <div className="bg-white/20 rounded-lg p-4">
                        <p className="text-sm text-purple-100 mb-1">이번 달</p>
                        <p className="text-2xl font-bold">₩1.85M</p>
                      </div>
                      <div className="bg-white/20 rounded-lg p-4">
                        <p className="text-sm text-purple-100 mb-1">지난 달</p>
                        <p className="text-2xl font-bold">₩2.12M</p>
                      </div>
                      <div className="bg-white/20 rounded-lg p-4">
                        <p className="text-sm text-purple-100 mb-1">평균</p>
                        <p className="text-2xl font-bold">₩1.85M</p>
                      </div>
                    </div>
                  </div>

                  <div className="bg-white rounded-xl shadow-sm p-6">
                    <h3 className="text-xl font-bold text-gray-900 mb-6">월별 수익 내역</h3>
                    <div className="space-y-4">
                      {[
                        { month: '2025년 1월', revenue: 1850000, views: 12500, talent: 92500 },
                        { month: '2024년 12월', revenue: 2120000, views: 14300, talent: 106000 },
                        { month: '2024년 11월', revenue: 1780000, views: 11200, talent: 89000 },
                        { month: '2024년 10월', revenue: 1950000, views: 13100, talent: 97500 }
                      ].map((item, index) => (
                        <div key={index} className="border border-gray-200 rounded-lg p-4">
                          <div className="flex items-center justify-between mb-3">
                            <p className="font-semibold text-gray-900">{item.month}</p>
                            <p className="text-xl font-bold text-green-600">₩{item.revenue.toLocaleString()}</p>
                          </div>
                          <div className="grid grid-cols-2 gap-4 text-sm">
                            <div>
                              <p className="text-gray-600">조회수</p>
                              <p className="font-semibold text-gray-900">{item.views.toLocaleString()}</p>
                            </div>
                            <div>
                              <p className="text-gray-600">달란트 적립</p>
                              <p className="font-semibold text-amber-600">{item.talent.toLocaleString()}</p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}

              {activeTab === 'analytics' && (
                <div className="space-y-6">
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    <div className="bg-white rounded-xl shadow-sm p-6">
                      <div className="flex items-center justify-between mb-4">
                        <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                          <i className="ri-eye-line text-2xl text-blue-600"></i>
                        </div>
                        <span className="text-sm text-green-600 font-semibold">+12.5%</span>
                      </div>
                      <p className="text-sm text-gray-600 mb-1">이번 달 조회수</p>
                      <p className="text-3xl font-bold text-gray-900">12,500</p>
                    </div>
                    <div className="bg-white rounded-xl shadow-sm p-6">
                      <div className="flex items-center justify-between mb-4">
                        <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center">
                          <i className="ri-heart-line text-2xl text-purple-600"></i>
                        </div>
                        <span className="text-sm text-green-600 font-semibold">+8.3%</span>
                      </div>
                      <p className="text-sm text-gray-600 mb-1">좋아요</p>
                      <p className="text-3xl font-bold text-gray-900">3,450</p>
                    </div>
                    <div className="bg-white rounded-xl shadow-sm p-6">
                      <div className="flex items-center justify-between mb-4">
                        <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
                          <i className="ri-share-line text-2xl text-green-600"></i>
                        </div>
                        <span className="text-sm text-green-600 font-semibold">+15.7%</span>
                      </div>
                      <p className="text-sm text-gray-600 mb-1">공유</p>
                      <p className="text-3xl font-bold text-gray-900">1,234</p>
                    </div>
                  </div>

                  <div className="bg-white rounded-xl shadow-sm p-6">
                    <h3 className="text-xl font-bold text-gray-900 mb-6">조회수 추이</h3>
                    <div className="space-y-3">
                      {[
                        { date: '1월 15일', views: 850 },
                        { date: '1월 14일', views: 920 },
                        { date: '1월 13일', views: 780 },
                        { date: '1월 12일', views: 1050 },
                        { date: '1월 11일', views: 890 }
                      ].map((item) => (
                        <div key={item.date}>
                          <div className="flex items-center justify-between mb-1">
                            <span className="text-sm text-gray-600">{item.date}</span>
                            <span className="text-sm font-semibold text-gray-900">{item.views.toLocaleString()}</span>
                          </div>
                          <div className="w-full bg-gray-200 rounded-full h-2">
                            <div className="bg-purple-600 h-2 rounded-full" style={{ width: `${(item.views / 1050) * 100}%` }}></div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="bg-white rounded-xl shadow-sm p-6">
                    <h3 className="text-xl font-bold text-gray-900 mb-6">사용자 참여도</h3>
                    <div className="grid grid-cols-2 gap-6">
                      <div>
                        <p className="text-sm text-gray-600 mb-2">평균 시청 시간</p>
                        <p className="text-3xl font-bold text-gray-900">8분 32초</p>
                      </div>
                      <div>
                        <p className="text-sm text-gray-600 mb-2">완료율</p>
                        <p className="text-3xl font-bold text-gray-900">78%</p>
                      </div>
                      <div>
                        <p className="text-sm text-gray-600 mb-2">댓글 수</p>
                        <p className="text-3xl font-bold text-gray-900">1,567</p>
                      </div>
                      <div>
                        <p className="text-sm text-gray-600 mb-2">재생 횟수</p>
                        <p className="text-3xl font-bold text-gray-900">15,234</p>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {activeTab === 'talent' && (
                <div className="space-y-6">
                  <div className="bg-gradient-to-br from-amber-500 to-amber-600 rounded-xl shadow-lg p-8 text-white">
                    <p className="text-lg mb-2">달란트 정산 내역</p>
                    <div className="flex items-center space-x-3 mb-6">
                      <i className="ri-coin-line text-5xl"></i>
                      <p className="text-5xl font-bold">92,500</p>
                    </div>
                    <div className="grid grid-cols-2 gap-4">
                      <div className="bg-white/20 rounded-lg p-4">
                        <p className="text-sm text-amber-100 mb-1">이번 달 적립</p>
                        <p className="text-2xl font-bold">+9,250</p>
                      </div>
                      <div className="bg-white/20 rounded-lg p-4">
                        <p className="text-sm text-amber-100 mb-1">정산 대기</p>
                        <p className="text-2xl font-bold">4,625</p>
                      </div>
                    </div>
                  </div>

                  <div className="bg-white rounded-xl shadow-sm p-6">
                    <h3 className="text-xl font-bold text-gray-900 mb-6">달란트 적립 내역</h3>
                    <div className="space-y-4">
                      {contents.map((content) => (
                        <div key={content.id} className="flex items-center justify-between pb-4 border-b border-gray-100 last:border-0">
                          <div className="flex-1">
                            <p className="font-medium text-gray-900">{content.title}</p>
                            <p className="text-sm text-gray-600">{content.date}</p>
                          </div>
                          <div className="text-right">
                            <p className="text-lg font-bold text-amber-600">+{content.talent.toLocaleString()}</p>
                            <p className="text-xs text-gray-600">{content.views.toLocaleString()} 조회</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="bg-white rounded-xl shadow-sm p-6">
                    <h3 className="text-xl font-bold text-gray-900 mb-6">월별 달란트 적립</h3>
                    <div className="space-y-4">
                      {[
                        { month: '2025년 1월', talent: 92500, status: '정산완료' },
                        { month: '2024년 12월', talent: 106000, status: '정산완료' },
                        { month: '2024년 11월', talent: 89000, status: '정산완료' },
                        { month: '2024년 10월', talent: 97500, status: '정산완료' }
                      ].map((item, index) => (
                        <div key={index} className="flex items-center justify-between pb-4 border-b border-gray-100 last:border-0">
                          <div>
                            <p className="font-medium text-gray-900">{item.month}</p>
                            <span className="text-xs px-2 py-1 bg-green-100 text-green-700 rounded-full">
                              {item.status}
                            </span>
                          </div>
                          <p className="text-xl font-bold text-amber-600">{item.talent.toLocaleString()}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
